import React, { FC } from "react";
import { IColor } from "../../utils/types/colors";
import { setClass } from "../../utils";

interface CalendarColorCircleProps {
  color: IColor;
  selectedColorName: string;
  onChangeColor: (colorName: string) => void;
}

export const CalendarColorCircle: FC<CalendarColorCircleProps> = ({ 
  color, selectedColorName, onChangeColor 
}) => {
  const onClick = () => onChangeColor(color.colorName);
        
  return (
    <div 
      className={setClass("color-circle", selectedColorName === color.colorName && 'active-color')} 
      style={{backgroundColor: color.hexCode}}
      onClick={onClick}
      key={color.hexCode}
    />
  )
}